import { render, staticRenderFns } from "./PopupAddMessengerVenue.vue?vue&type=template&id=27d7a975&scoped=true&"
import script from "./PopupAddMessengerVenue.vue?vue&type=script&lang=js&"
export * from "./PopupAddMessengerVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7a975",
  null
  
)

export default component.exports